<div class="flex flex-col" style="height: calc(100vh - 50px);">

  <!-- Orange banner -->
  <div class="px-8 py-6 flex-shrink-0" style="background: var(--color-action);">
    <div class="flex items-center gap-3">
      <button
        type="button"
        (click)="goBack()"
        class="flex items-center justify-center h-8 w-8 rounded-full hover:bg-white/20 transition flex-shrink-0"
        matTooltip="Back to Guides"
        >
        <mat-icon class="text-white" svgIcon="c:arrow-left"></mat-icon>
      </button>
      <div>
        <h2 class="text-xl font-semibold text-white">{{ guideName }}</h2>
        <p class="mt-0.5 text-sm text-white/80">Interactive Guides</p>
      </div>
    </div>
  </div>

  <!-- Iframe -->
  @if (safeUrl) {
    <iframe
      [src]="safeUrl"
      class="w-full flex-1 border-0"
      style="min-height: 0;"
      allowfullscreen
    ></iframe>
  }

</div>
